var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-span"},[(_vm.filter)?_c('span',[_vm._v(_vm._s(_vm._f("preFilter")(_vm.data , _vm.filter)))]):_c('span',[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }